import { ExecutiveSummaryStatus, LoadingStatusType, PeakExceptionResponseCode, TypeComponentNoti } from "@/enums/enums";
import { ConvertToCreateExecutiveSummaryTransaction } from "@/helper/executiveSummaryHelper";
import { GetMessageExceptionCode } from "@/helper/shareHelper";
import { SetTapsExecutiveSummaryTable } from "@/helper/tableHelper";
import { MerchantId } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import { ExecutiveSummaryTransactionModel } from "@/model/executiveSummary/executiveSummaryModel";
import { ExecutiveSummaryTableModel } from "@/model/executiveSummary/executiveSummaryTableModel";
import router from "@/router";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
@Module({ namespaced: true })
class ExecutiveSummary extends VuexModule {
  private executiveSummaryTableLoadingStatus = LoadingStatusType.None;
  private executiveSummaryTableTap: any = [];
  private executiveSummaryTable: Array<ExecutiveSummaryTableModel> = [];
  private executiveSummaryTransaction: ExecutiveSummaryTransactionModel = new ExecutiveSummaryTransactionModel();
  private executiveSummaryTransactionLoadingStatus = LoadingStatusType.None;
  private createExecutiveSummaryTransactionLoadingStatus = LoadingStatusType.None;
  private suggestionExecusiveSummaryNumberLoadingStatus = LoadingStatusType.None;
  private executiveSummaryDetailLoadingStatus = LoadingStatusType.None;
  private exportExecutiveSummaryLoadingStatus = LoadingStatusType.None;
  private showModalChangeDocumentNumber = false;

  get getExecutiveSummaryDetailLoadingStatusLoadingStatus(): LoadingStatusType {
    return this.executiveSummaryDetailLoadingStatus;
  }
  get getExecutiveSummaryTransactionLoadingStatus(): LoadingStatusType {
    return this.executiveSummaryTransactionLoadingStatus;
  }
  get getExecutiveSummaryTransaction(): ExecutiveSummaryTransactionModel {
    return this.executiveSummaryTransaction;
  }
  get getExecutiveSummaryTableLoadingStatus(): LoadingStatusType {
    return this.executiveSummaryTableLoadingStatus;
  }
  get getExecutiveSummaryTableTap(): any {
    return this.executiveSummaryTableTap;
  }
  get getExecutiveSummaryTable(): Array<ExecutiveSummaryTableModel> {
    return this.executiveSummaryTable;
  }
  get getExportExecutiveSummaryLoadingStatus(): LoadingStatusType {
    return this.exportExecutiveSummaryLoadingStatus;
  }
  get getCreateExecutiveSummaryTransactionLoadingStatus(): LoadingStatusType {
    return this.createExecutiveSummaryTransactionLoadingStatus;
  }
  get getShowModalChangeDocumentNumber(): boolean {
    return this.showModalChangeDocumentNumber;
  }

  @Mutation
  public SetExecutiveSummaryTableLoadingStatus(status: LoadingStatusType) {
    this.executiveSummaryTableLoadingStatus = status;
  }
  @Mutation
  public SetExecutiveSummaryDetailLoadingStatus(status: LoadingStatusType) {
    this.executiveSummaryDetailLoadingStatus = status;
  }
  @Mutation
  public SetExecutiveSummaryTransaction(transaction: ExecutiveSummaryTransactionModel) {
    this.executiveSummaryTransaction = transaction;
  }
  @Mutation
  public SetExecutiveSummaryTransactionLoadingStatus(status: LoadingStatusType) {
    this.executiveSummaryTransactionLoadingStatus = status;
  }
  @Mutation
  public SetCreateExecutiveSummaryTransactionLoadingStatus(status: LoadingStatusType) {
    this.createExecutiveSummaryTransactionLoadingStatus = status;
  }
  @Mutation
  public SetExecutiveSummaryTable(table: any): void {
    this.executiveSummaryTable = [];
    this.executiveSummaryTableTap = SetTapsExecutiveSummaryTable;
  }
  @Mutation
  public SetSuggestionExecusiveSummaryNumberLoadingStatus(status: LoadingStatusType) {
    this.suggestionExecusiveSummaryNumberLoadingStatus = status;
  }
  @Mutation
  public SetExportExecutiveSummaryLoadingStatus(status: LoadingStatusType) {
    this.executiveSummaryTableLoadingStatus = status;
  }
  @Mutation
  public SetShowModalChangeDocumentNumber(status: boolean) {
    this.showModalChangeDocumentNumber = status;
  }
  @Mutation
  public ResetShowModalChangeDocumentNumber() {
    this.showModalChangeDocumentNumber = false;
  }
  @Action
  public DoSetExecutiveSummaryTransaction(transaction: ExecutiveSummaryTransactionModel) {
    this.context.commit("SetExecutiveSummaryTransaction", transaction);
  }
  @Action
  public DoSetCreateExecutiveSummaryTransactionLoadingStatus(status: LoadingStatusType) {
    this.context.commit("SetExecutiveSummaryTransactionLoadingStatus", status);
  }
  @Action
  public DoGetExecutiveSummaryTransactionForCreate(input: any) {
    if (this.executiveSummaryTransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetExecutiveSummaryTransactionLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.ExecutiveSummaryService.DoGetExecutiveSummaryTransactionForCreate(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const executiveSummaryTransaction = ConvertToCreateExecutiveSummaryTransaction(
            res.data.transaction,
            input.fromDate,
            input.toDate
          );
          this.context.commit("SetExecutiveSummaryTransaction", executiveSummaryTransaction);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("SetExecutiveSummaryTransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoCreateExecutiveSummary(input: any) {
    if (this.createExecutiveSummaryTransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetCreateExecutiveSummaryTransactionLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      API.ExecutiveSummaryService.DoCreateExecutiveSummary(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          router.push({
            name: "executiveSummaryDetail",
            query: { emi: MerchantId().PeakEncryption(), eesi: res.data.inserted.id.PeakEncryption() },
          });

          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Create_ExecutiveSummary_Success", {
                number: input.number,
              }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else if (res.data.exception.code === PeakExceptionResponseCode.TransactionNumberDuplicated) {
          this.context.commit("SetShowModalChangeDocumentNumber", true);
        } else if (res.data.responseCode.IsSeeOther()) {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }

        this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("SetCreateExecutiveSummaryTransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoUpdateExecutiveSummary(input: any) {
    if (this.createExecutiveSummaryTransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetCreateExecutiveSummaryTransactionLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      API.ExecutiveSummaryService.DoUpdateExecutiveSummary(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (input.redirectToDetail) {
            router.push({
              name: "executiveSummaryDetail",
              query: { emi: MerchantId().PeakEncryption(), eesi: input.executiveSummaryId.PeakEncryption() },
            });
          } else {
            router.push({
              name: "executiveSummary",
              query: { emi: MerchantId().PeakEncryption(), stid: "1" },
            });
          }

          if (input.status == ExecutiveSummaryStatus.Approve) {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Approved_ExecutiveSummary_Success", {
                  number: input.executiveSummary.number,
                }),
                typeMessage: TypeComponentNoti.Success,
              },
              { root: true }
            );
          } else {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Updare_ExecutiveSummary_Success", {
                  number: input.executiveSummary.number,
                }),
                typeMessage: TypeComponentNoti.Success,
              },
              { root: true }
            );
          }
        } else if (res.data.exception.code === PeakExceptionResponseCode.TransactionNumberDuplicated) {
          this.context.commit("SetShowModalChangeDocumentNumber", true);
        } else if (res.data.responseCode.IsSeeOther()) {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }

        this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("SetCreateExecutiveSummaryTransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public async DoGetSuggestionExecusiveSummaryNumber(input: any) {
    if (this.suggestionExecusiveSummaryNumberLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetSuggestionExecusiveSummaryNumberLoadingStatus", LoadingStatusType.Loading);
      let res = await API.ExecutiveSummaryService.DoGetSuggestionExecusiveSummaryNumber(input);
      this.context.commit("SetSuggestionExecusiveSummaryNumberLoadingStatus", LoadingStatusType.Success);
      if (res.data.responseCode.IsSuccess()) {
        return res.data.number;
      } else {
        return;
      }
    }
    return;
  }
  @Action
  public async DoGetExecutiveSummaryDetail(executiveSummaryId: number) {
    if (this.executiveSummaryDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetExecutiveSummaryDetailLoadingStatus", LoadingStatusType.Loading);
      let res = await API.ExecutiveSummaryService.DoGetExecutiveSummaryDetail(executiveSummaryId);
      this.context.commit("SetExecutiveSummaryDetailLoadingStatus", LoadingStatusType.Success);
      if (res.data.responseCode.IsSuccess()) {
        return res.data.detail;
      } else {
        return;
      }
    }
    return;
  }
  @Action
  public DoVoidExecutiveSummary(input: any) {
    if (this.createExecutiveSummaryTransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetCreateExecutiveSummaryTransactionLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      API.ExecutiveSummaryService.DoVoidExecutiveSummary(input.id).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          router.push({
            name: "executiveSummary",
            query: { emi: MerchantId().PeakEncryption() },
          });

          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Voided_Document_Success", {
                msg: input.number,
              }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else if (res.data.responseCode.IsSeeOther()) {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }

        this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("SetCreateExecutiveSummaryTransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoUpdateExecutiveSummaryStatus(input: any) {
    if (this.createExecutiveSummaryTransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetCreateExecutiveSummaryTransactionLoadingStatus", LoadingStatusType.Loading);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      API.ExecutiveSummaryService.DoUpdateExecutiveSummaryStatus(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Approved_ExecutiveSummary_Success", {
                number: input.number,
              }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else if (res.data.responseCode.IsSeeOther()) {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        this.context.commit("SetCreateExecutiveSummaryTransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoSetExecutiveSummaryTableLoadingStatus(status: LoadingStatusType) {
    this.context.commit("SetExecutiveSummaryTableLoadingStatus", status);
  }
  @Action
  public async DoGetExecutiveSummaryTable(input: any) {
    let table;
    if (this.executiveSummaryTableLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetExecutiveSummaryTableLoadingStatus", LoadingStatusType.Loading);
      let res = await API.ExecutiveSummaryService.DoGetExecutiveSummaryTable(input);
      if (res.status.IsSuccess()) {
        table = res.data.transactionTable;
      }
    }
    return table;
  }
  @Action
  public async DoExportExecutiveSummary(input: any) {
    if (this.exportExecutiveSummaryLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetExportExecutiveSummaryLoadingStatus", LoadingStatusType.Loading);
      await API.ExecutiveSummaryService.DoExportExecutiveSummary(input);
      let alertMessage: any = "";
      let typeMessage = TypeComponentNoti.Success;

      this.context.commit("SetExportExecutiveSummaryLoadingStatus", LoadingStatusType.Success);
      if (input.isSendEmail) {
        alertMessage = i18n.t("This_Report_Is_Sent_Email", { email: input.receiveEmailList.join(", ") });
      } else {
        alertMessage = i18n.t("Report_Ready");
      }
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: alertMessage,
          typeMessage: typeMessage,
        },
        { root: true }
      );
    }
    return;
  }
  @Action
  public DoResetShowModalChangeDocumentNumber() {
    this.context.commit("ResetShowModalChangeDocumentNumber");
  }
}

export default ExecutiveSummary;
